import { render, staticRenderFns } from "./SubmerchantPerformancePage.vue?vue&type=template&id=e920d400&"
import script from "./SubmerchantPerformancePage.vue?vue&type=script&lang=js&"
export * from "./SubmerchantPerformancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports